/* =============================================================================
DB:       Realtime DB
PURPOSE:  Stores dayplanner sessions
============================================================================= */

import moment from '@/moment-gp'

export default {
  VALID_CHECKLIST_ITEM_STATES: ['completed', 'incomplete'],

  create({ dateString, taskId, sessionId }, data, BACKEND) {
    return {
      createdAt:          moment.currentTimeServer('REALTIMEDB'),
      dateString:         data.dateString,
      taskId:             data.taskId,
      sessionId:          data.sessionId,
      commitmentId:       data.commitmentId,
      goalId:             data.goalId,
      assignedUserId:     data.assignedUserId,
      finishedAt:         data.finishedAt || null,
      finished:           data.finished || false
    }
  },

  fields: {
    createdAt: { validate_bolt_type: 'ServerTimestamp' },
    dateString: { validate_bolt_type: 'YYMMDDDate' },
    taskId: { validate_bolt_type: 'PushID' },
    sessionId: { validate_bolt_type: 'PushID' },
    commitmentId: { validate_bolt_type: 'AnyID' }, // TODO: PushID
    goalId: { validate_bolt_type: 'AnyID' }, // TODO: PushID
    assignedUserId: { validate_bolt_type: 'UserID' },
    finishedAt: { validate_bolt_type: 'Timestamp' }, // when the task was marked as done
    finished: { validate_bolt_type: 'Boolean' }
    //removed: { validate_bolt_type: 'Boolean' }, // when the task was removed from a session
  }
};
